
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Countup from 'vux/src/components/countup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'


export default {
components: {
Datetime,
PopupPicker,
Countup,
Popup,Group,PopupHeader,XButton,Radio
},
directives: {
TransferDom
},
data() {
return {
community1Pop:false,
community2Pop:false,
community3Pop:false,
showDates:false,
pickerStatus:false,
dateStatus:false,
index:0,
startDate:'',
endDate:'',
list:{
total:{total:0,pickShoe:0,pickClothe:0,sendShoe:0,sendClothe:0},
community1:[

],
community2:[

],
community3:[

]
}

}
},
created(){
if(!this.$func.getLocal('factory_token')){
this.$router.push({path:'/factoryData'});
}else{
this.setDate();
setTimeout(() => {
this.getData();
}, 300);
}
},
methods: {
setDate() {
const now = new Date();
const currentHour = now.getHours();
if(currentHour < 8){
this.startDate = this.$func.modifyDate(this.$func.getCurrentDate(),-1);
}else{
this.startDate = this.$func.getCurrentDate();
}
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
previous(){
this.startDate = this.$func.modifyDate(this.startDate,-1);
this.getData();
},
next(){
this.startDate = this.$func.modifyDate(this.startDate,1);
this.getData();
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}
setTimeout(() => {
this.getData();
}, 300);
},
reset(){
this.setDate();
setTimeout(() => {
this.getData();
}, 300);
},
getData() {
this.list = {
total:{total:0,pickShoe:0,pickClothe:0,sendShoe:0,sendClothe:0},
community1:[],
community2:[],
community3:[]
};
this.$func.startLoading();
this.$api.sendPickCountData({date:this.startDate}).then((res)=>{
if(res){
this.list = res.data;
this.pickerStatus = false;
this.$func.endLoading();
}
})
},

}
}



// WEBPACK FOOTER //
// ./src/pages/sendPickCountData.vue